import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next'; // import _ from 'lodash'
// import cx from 'classnames'
// import { useSelector, useDispatch } from 'react-redux'

import moment from 'moment';
import ModalDialog from '../ui/modal-dialog';
import ITSVideoPlayer from '../../utils/ITS-videoPlayer';
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var VideoPlayerPopup = /*#__PURE__*/React.memo(function (props) {
  // redux
  // const {} = useSelector(state => state.toJS())
  // const dispatch = useDispatch()
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      streamUrl = _useState2[0],
      setStreamUrl = _useState2[1];

  var _interval = useRef();

  var id = props.id,
      onClose = props.onClose,
      videoData = props.videoData;

  var handleClose = function handleClose() {
    onClose();
  };

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: handleClose
  }); // const renderVideoplayer = () => {
  //     switch(videoData.dataSource.toUpperCase()) {
  //         case 'EVMS':
  //             return <ITSVideoPlayer streamUrl={videoData.streamUrl } />
  //         case 'FREEWAY':
  //             return <img src={streamUrl ? streamUrl : videoData.streamUrl} />
  //         case 'TBKC':
  //             let p = _.filter(videoData.streamUrl.split('&'), el => el.indexOf('w=') >= 0 || el.indexOf('h=') >= 0)
  //             let w = _.find(p, el => el.indexOf('w') >= 0).split('=')[1]
  //             let h = _.find(p, el => el.indexOf('h') >= 0).split('=')[1]
  //             return <iframe src={videoData.streamUrl} width={Number(w)+12} height={Number(h)+50} />
  //     }
  // }
  // useEffect(() => {
  //     if(videoData.dataSource.toUpperCase() === 'FREEWAY') {
  //         _interval.current = setInterval(() => {
  //             let timeStamp = new moment().valueOf()
  //             setStreamUrl(`${videoData.streamUrl}&t=${timeStamp}`)
  //         }, 6000)
  //     }
  //     return (() => {
  //         clearInterval(_interval.current)
  //         _interval.current = null
  //     })
  // }, [])


  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: gt('top-message.lbl-live'),
    global: true,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement("div", {
    className: "camera-content"
  }, /*#__PURE__*/React.createElement(ITSVideoPlayer, {
    videoData: videoData
  }), /*#__PURE__*/React.createElement("div", {
    className: "camera-info"
  }, /*#__PURE__*/React.createElement("p", {
    className: "camera-name"
  }, videoData.name), /*#__PURE__*/React.createElement("p", {
    className: "camera-area"
  }, videoData.location))));
});
VideoPlayerPopup.defaultProps = {
  id: 'g-videoPlayer-popup'
};
VideoPlayerPopup.propTypes = {
  id: PropTypes.string,
  cameraData: PropTypes.object
};
export default VideoPlayerPopup;